import { render, staticRenderFns } from "./ClaimHandler.vue?vue&type=template&id=7fd99703"
import script from "./ClaimHandler.vue?vue&type=script&lang=js"
export * from "./ClaimHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports